import React, { useEffect, useState } from "react";
import { Get, GetWithBody, Post } from "../api/ApiCallerService";


export function usePost(endpoint, language,body) {
  const [data, setData] = useState(null)
  const [error, setError] = useState(false)
  useEffect(() => {
    Post(endpoint, language, body)
      .then((response) => {
        switch (response.status) {
          case 200:
            response.json().then((args) => {
              setData(args["result"]["data"])
            });

            break;

          default:
            setError(true)
            break;
        }
      })
      .catch((error) => {
        setError(true)
      });

  }, [language, endpoint])

  return [data, error];
}

export function useGet(endpoint) {
  const [data, setData] = useState(null)
  const [error, setError] = useState(false)
  useEffect(() => {
    Get(endpoint)
      .then((response) => {
        switch (response.status) {
          case 200:
            response.json().then((args) => {
              setData(args["result"]["data"])
            });

            break;

          default:
            setError(true)
            break;
        }
      })
      .catch((error) => {
        setError(true)
      });

  }, [endpoint])

  return [data, error];
}

export function useWindowSize() {
  const [size, setSize] = useState([window.innerHeight, window.innerWidth]);
  useEffect(() => {
    const handleResize = () => {
      setSize([window.innerHeight, window.innerWidth]);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return size;
}